import {Component, Input} from '@angular/core';
import {AbstractProdForm, ProdFormField, ProdFormFieldType, ProdFormValidators, RequiredValidator, MustMatchValidator} from "prod-form";
import {UserService} from "../../../services/user.service";
import {first, take} from "rxjs";
import {Router} from "@angular/router";
import {AuthenticationService} from "../../../services/authentication.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['../login.component.scss']
})
export class ResetPasswordComponent extends AbstractProdForm {
  @Input() resetPasswordData: {username: string, token: string};
  title: string = this.translate.instant('reset_password.title');
  formValidators: ProdFormValidators = new ProdFormValidators([new MustMatchValidator('password', 'confirmPassword', this.translate.instant('reset_password.password'))])
  fields: ProdFormField[] = [
    ProdFormField.create({
      type: ProdFormFieldType.TEXT,
      name: 'username',
      label: this.translate.instant('reset_password.username'),
      validators: new ProdFormValidators([new RequiredValidator()]),
      disabledOnAdd: true,
    }),
    ProdFormField.create({
      type: ProdFormFieldType.PASSWORD,
      name: 'password',
      label: this.translate.instant('reset_password.password'),
      validators: new ProdFormValidators([new RequiredValidator()])
    }),
    ProdFormField.create({
      type: ProdFormFieldType.PASSWORD,
      name: 'confirmPassword',
      label: this.translate.instant('reset_password.confirm_password'),
      validators: new ProdFormValidators([new RequiredValidator()])
    })
  ];

  constructor(private router: Router, private userService: UserService, private authenticationService: AuthenticationService, private translate: TranslateService) {
    super();

  }

  ngOnInit(): void {
    this.fields[0].value = this.resetPasswordData.username;
  }

  override post(data) {
    this.userService.resetPassword(this.resetPasswordData.username, data.password, this.resetPasswordData.token)
      .pipe(take(1)).subscribe(res => {
      if (res['success']) {
        this.authenticationService.login(this.resetPasswordData.username, data.password).pipe(first())
          .subscribe(
        res => {
              this.getAuthenticatedUser(res.token)
            },
            error => {
              console.log(error);
            }
          );
      }
    });
  }

  getAuthenticatedUser(token) {
    this.authenticationService.getAuthenticatedUser(token)
      .pipe(first())
      .subscribe(
        res => {
          this.router.navigate(['/']).then(() => window.location.reload());
        },
        error => {
          console.log(error);
        }
      );
  }
}
